import * as React from 'react';
import * as _ from 'lodash';
import { FilterGroupValuesList } from './../FilterGroupValuesList';
export default function () {
    function onClick1(s, sIndex, e) {
        this.excludeStone(s);
    }
    function repeatS2(s, sIndex) {
        return React.createElement('li', {
            'className': 'assign-popup-selected-stones__list-item',
            'key': s.id
        }, React.createElement('div', {
            'className': 'ui-svg-checkbox',
            'onClick': onClick1.bind(this, s, sIndex)
        }, React.createElement('div', { 'className': 'ui-svg-checkbox__icon' }, React.createElement('svg', {
            'className': 'ui-svg-checkbox__icon-circle',
            'height': '30',
            'width': '30'
        }, React.createElement('circle', {
            'cx': '15',
            'cy': '15',
            'r': '12.5',
            'stroke': '#979797',
            'strokeWidth': '3',
            'fill': '#ffffff'
        })), !this.state.excludedStones[s.id] ? React.createElement('div', {
            'className': 'ui-svg-checkbox__icon-checked-icon',
            'key': '1144'
        }) : null), React.createElement('div', { 'className': 'ui-svg-checkbox__text' }, s.name)));
    }
    function onClick3() {
        this.props.closePopup();
    }
    function onClick4() {
        this.handleSave();
    }
    return React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Assign Filters')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'assign-popup' }, React.createElement('div', { 'className': 'assign-popup-content' }, React.createElement('div', { 'className': 'add-stone-container' }, React.createElement('div', { 'className': 'add-stone-col-1' }, React.createElement('div', { 'className': 'assign-popup-title' }, 'Selected Stones'), React.createElement('div', { 'className': 'assign-popup-selected-stones' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-popup-selected-stones__list ui-list' },
        _.map(this.props.stones, repeatS2.bind(this))
    ]))), React.createElement('div', { 'className': 'wrapper' }, React.createElement('h2', {}, 'Assign Material Filter'), React.createElement(FilterGroupValuesList, {
        'filterItems': this.state.materialsFilterGroup.values || [],
        'type': 'materials',
        'handleFilterClick': this.handleFilterClick,
        'containerClass': 'add-stone-col-2'
    })), React.createElement('div', { 'className': 'wrapper' }, React.createElement('h2', {}, 'Assign Color Filter'), React.createElement(FilterGroupValuesList, {
        'filterItems': this.state.colorsFilterGroup.values || [],
        'type': 'colors',
        'handleFilterClick': this.handleFilterClick,
        'containerClass': 'add-stone-col-3'
    })))))), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': onClick3.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), this.props.stones.length ? React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick4.bind(this),
        'key': '2460'
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save')) : null));
}